// Copyright 2023-2024 - Hewlett Packard Enterprise Company
import { Alert as BaseAlert } from 'grommet-icons/icons/Alert';
import { CircleAlert as BaseCircleAlert } from 'grommet-icons/icons/CircleAlert';
import { CircleInformation as BaseCircleInformation } from 'grommet-icons/icons/CircleInformation';
// eslint-disable-next-line max-len
import { StatusCriticalSmall as BaseStatusCriticalSmall } from 'grommet-icons/icons/StatusCriticalSmall';
import { StatusDisabled as BaseStatusDisabled } from 'grommet-icons/icons/StatusDisabled';
import { StatusGood as BaseStatusGood } from 'grommet-icons/icons/StatusGood';
import { StatusGoodSmall as BaseStatusGoodSmall } from 'grommet-icons/icons/StatusGoodSmall';
// eslint-disable-next-line max-len
import { StatusUnknownSmall as BaseStatusUnknownSmall } from 'grommet-icons/icons/StatusUnknownSmall';
import { StatusWarning as BaseStatusWarning } from 'grommet-icons/icons/StatusWarning';
// eslint-disable-next-line max-len
import { StatusWarningSmall as BaseStatusWarningSmall } from 'grommet-icons/icons/StatusWarningSmall';

const withHeightWrapper =
  Component =>
  ({ height, size, ...rest }) => {
    const adjustedHeight = height || size || 'medium';
    return <Component height={adjustedHeight} size={size} {...rest} />;
  };
export const Alert = withHeightWrapper(BaseAlert);
export const CircleAlert = withHeightWrapper(BaseCircleAlert);
export const CircleInformation = withHeightWrapper(BaseCircleInformation);
export const StatusCriticalSmall = withHeightWrapper(BaseStatusCriticalSmall);
export const StatusDisabled = withHeightWrapper(BaseStatusDisabled);
export const StatusGood = withHeightWrapper(BaseStatusGood);
export const StatusGoodSmall = withHeightWrapper(BaseStatusGoodSmall);
export const StatusUnknownSmall = withHeightWrapper(BaseStatusUnknownSmall);
export const StatusWarning = withHeightWrapper(BaseStatusWarning);
export const StatusWarningSmall = withHeightWrapper(BaseStatusWarningSmall);
